import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import * as ApiRoute from 'constants/apiRouting'
import {
  FETCH_SEA_LICE_DATA,
  SUCCESS_SEA_LICE_DATA,
  FAILURE_SEA_LICE_DATA,
  FETCH_SPECIES_LIST,
  SET_SPECIES_LIST,
  FETCH_BARRIOS_ACTIVE_LIST,
  SET_BARRIOS_ACTIVE_LIST,
  FETCH_LAST_SEA_LICE_DATE,
  FETCH_LAST_SEA_LICE_DATE_SUCCESS,
} from './reducer'

function* fetchSeaLiceData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SEA_LICE_DATA, action.payload),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_SEA_LICE_DATA, payload: response })
    } else {
      yield put({ type: FAILURE_SEA_LICE_DATA })
    }
  } catch (error) {
    console.log('SEA_LICE FAILED ', error)
  }
}

function* fetchSpeciesList() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.SEA_LICE_SPECIES_LIST,
    })

    yield put({
      type: SET_SPECIES_LIST,
      payload: {
        list: response,
      },
    })
  } catch (error) {
    console.log('SEA_LICE FAILED ', error)
  }
}

function* fetchActiveBarriosList() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.BARRIOS_ACTIVE_LIST,
    })

    yield put({
      type: SET_BARRIOS_ACTIVE_LIST,
      payload: {
        list: response,
      },
    })
  } catch (error) {
    console.log('SEA_LICE FAILED ', error)
  }
}

function* fetchLastSeaLiceDate(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.SEA_LICE_LAST_DATE, action.payload),
    })

    yield put({
      type: FETCH_LAST_SEA_LICE_DATE_SUCCESS,
      payload: response,
    })
  } catch (error) {
    console.log('SEALICE FAILED ', error)
  }
}

function* seaLiceSagaSaga() {
  yield takeLatest(FETCH_SEA_LICE_DATA, fetchSeaLiceData)
  yield takeLatest(FETCH_SPECIES_LIST, fetchSpeciesList)
  yield takeLatest(FETCH_BARRIOS_ACTIVE_LIST, fetchActiveBarriosList)
  yield takeLatest(FETCH_LAST_SEA_LICE_DATE, fetchLastSeaLiceDate)
}

export default seaLiceSagaSaga
